// extracted by mini-css-extract-plugin
module.exports = {"blockLoader":"styles_blockLoader__3a0Ho","wrapper":"styles_wrapper__1ehVw"};